import React, { useState, useEffect, useRef } from "react";
import { FaMapMarkerAlt, FaStar, FaUtensils } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SidescrollAdvertisements from "../Landingpages/Profile/SidescrollAdvertisements";
import { FaArrowRight } from "react-icons/fa";
import Modal from "react-modal";

const BASE_URL = "https://backend.maamaas.com/food";

Modal.setAppElement("#root");

// ✅ CSS Styles - Add this right after imports
const styles = {
    restaurantCardsContainer: {
        padding: "20px",
        fontFamily: "'Arial', sans-serif",
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
    },
    mainContentWrapper: {
        display: "flex",
        gap: "20px",
        maxWidth: "1200px",
        margin: "0 auto",
    },
    cardsContainer: {
        flex: "7",
        height: "650px",
        overflow: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
    },
    cardsContainerScroll: {
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    cardsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: "20px",
        padding: "10px",
    },
    restaurantCard: {
        backgroundColor: "white",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        transition: "all 0.3s ease",
        cursor: "pointer",
        border: "1px solid #e0e0e0",
        "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
        },
    },
    cardImageWrapper: {
        position: "relative",
        height: "160px",
        overflow: "hidden",
    },
    cardBanner: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        transition: "transform 0.3s ease",
    },
    cardTopBar: {
        position: "absolute",
        top: "10px",
        left: "10px",
        right: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
    },
    cardLogo: {
        width: "50px",
        height: "50px",
        borderRadius: "8px",
        border: "2px solid white",
        backgroundColor: "white",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
    },
    offerBadge: {
        backgroundColor: "#49b617ff",
        color: "white",
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "12px",
        fontWeight: "bold",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    },
    cardContent: {
        padding: "15px",
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: "8px",
    },
    companyName: {
        fontSize: "18px",
        fontWeight: "bold",
        color: "#2d3436",
        margin: "0",
        lineHeight: "1.3",
        flex: "1",
        marginRight: "10px",
    },
    cardRating: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#a9a6acff",
        color: "white",
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: "bold",
        minWidth: "50px",
        justifyContent: "center",
    },
    starIcon: {
        marginLeft: "4px",
        fontSize: "12px",
    },
    cardSubtitle: {
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        color: "#636e72",
        margin: "8px 0",
        lineHeight: "1.4",
    },
    utensilsIcon: {
        marginRight: "6px",
        color: "#e17055",
        fontSize: "14px",
    },
    typeText: {
        fontWeight: "600",
        color: "#2d3436",
    },
    companyLocation: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "13px",
        color: "#636e72",
        marginTop: "10px",
        paddingTop: "10px",
        borderTop: "1px solid #f1f2f6",
    },
    locationLeft: {
        display: "flex",
        alignItems: "center",
        flex: "1",
    },
    locationIcon: {
        marginRight: "6px",
        color: "#e17055",
        fontSize: "12px",
    },
    cardDistance: {
        backgroundColor: "#f1f2f6",
        padding: "4px 8px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: "500",
        color: "#2d3436",
        whiteSpace: "nowrap",
    },
    loadingText: {
        textAlign: "center",
        fontSize: "16px",
        color: "#636e72",
        padding: "40px",
    },
    errorText: {
        textAlign: "center",
        color: "#ff4757",
        fontSize: "16px",
        padding: "40px",
    },
    emptyText: {
        textAlign: "center",
        color: "#636e72",
        fontSize: "16px",
        padding: "40px",
    },
    advertisementsColumn: {
        flex: "3",
    },
};

// ✅ Convert style objects to inline styles with hover effects
const RestaurantCard = ({ card, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            style={{
                ...styles.restaurantCard,
                transform: isHovered ? "translateY(-5px)" : "translateY(0)",
                boxShadow: isHovered
                    ? "0 8px 20px rgba(0, 0, 0, 0.15)"
                    : "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div style={styles.cardImageWrapper}>
                <img
                    src={card.bannerUrl}
                    alt="Banner"
                    style={{
                        ...styles.cardBanner,
                        transform: isHovered ? "scale(1.05)" : "scale(1)",
                    }}
                />
                <div style={styles.cardTopBar}>
                    <img src={card.logoUrl} alt="logo" style={styles.cardLogo} />
                    {card.offer && <div style={styles.offerBadge}>{card.offer}</div>}
                </div>
            </div>

            <div style={styles.cardContent}>
                <div style={styles.cardHeader}>
                    <h4 style={styles.companyName}>{card.companyName}</h4>
                    <div style={styles.cardRating}>
                        {card.rating}
                        <FaStar style={styles.starIcon} />
                    </div>
                </div>

                <p style={styles.cardSubtitle}>
                    {card.Type === "Restaurant" && <FaUtensils style={styles.utensilsIcon} />}
                    <span style={styles.typeText}>{card.Type}</span> - {card.subtitle}
                </p>

                <p style={styles.companyLocation}>
                    <span style={styles.locationLeft}>
                        <FaMapMarkerAlt style={styles.locationIcon} />
                        {card.city ? `${card.city}, ` : ""}
                        <span>{card.addressLine}</span>
                    </span>
                    <span style={styles.cardDistance}>{card.distance}</span>
                </p>
            </div>
        </div>
    );
};

const MainPageRestaurantCards = ({ cities }) => {
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [selectedBranch, setSelectedBranch] = useState("All");
    const [subCategory, setSubCategory] = useState("");
    const userId = localStorage.getItem("userId");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [cardsData, setCardsData] = useState([]);
    const [filteredCards, setFilteredCards] = useState([]);
    const [selectedBusinessType, setSelectedBusinessType] = useState("");
    const [selectedOutletType, setSelectedOutletType] = useState("");

    useEffect(() => {
        if (!selectedBranch) {
            setFilteredCards(cardsData);
        } else {
            setFilteredCards(cardsData.filter((card) => card.appType === selectedBranch));
        }
    }, [selectedBranch, cardsData]);

    useEffect(() => {
        let result = cards;

        if (search) {
            const searchTerm = search.toLowerCase();
            result = result.filter(
                (card) =>
                    card.companyName.toLowerCase().includes(searchTerm) ||
                    (card.subtitle &&
                        card.subtitle.toLowerCase().includes(searchTerm)) ||
                    (card.city && card.city.toLowerCase().includes(searchTerm))
            );
        }

        if (selectedBranch !== "All" && selectedBranch !== "") {
            result = result.filter(
                (card) => card.businessType === selectedBranch
            );
        }

        if (subCategory) {
            result = result.filter(
                (card) =>
                    card.subtitle &&
                    card.subtitle.toLowerCase().includes(subCategory.toLowerCase())
            );
        }

        setFilteredCards(result);
    }, [search, selectedBranch, subCategory, cards]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("authToken");
                const { data } = await axios.get(`${BASE_URL}/api/bannner/getall`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const safe = (Array.isArray(data) ? data : []).map((b) => ({
                    ...b,
                    vendorId: b.vendorId || b.id,
                    bannerUrl: b.companyBanner,
                    logoUrl: b.companyLogo,
                    rating: (Math.random() * (5 - 3.5) + 3.5).toFixed(1),
                    offer: "Flat 10% OFF",
                    addressLine: b.addressLine || "Unknown Location",
                    subtitle: b.subtitle || "North Indian, Chinese",
                    Type: b.Type || "Restaurant",
                    price: b.price || "₹2000 for two",
                    distance: (Math.random() * 10).toFixed(1) + " km",
                    promoted: true,
                    appType: b.appType || "FOOD_AND_BEVERAGES",
                }));

                setCards(safe);
                setFilteredCards(safe);
            } catch (e) {
                console.error("❌ Fetch error:", e);
                setError("Unable to load vendors.");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    useEffect(() => {
        let filtered = cards;
        if (selectedBusinessType) {
            filtered = filtered.filter((c) => c.appType === selectedBusinessType);
        }
        if (selectedOutletType) {
            filtered = filtered.filter((c) => c.Type?.toUpperCase() === selectedOutletType.toUpperCase());
        }
        setFilteredCards(filtered);
    }, [selectedBusinessType, selectedOutletType, cards]);

    const handleCardClick = (vendorId) => {
        localStorage.setItem("vendorId", vendorId);
        navigate("/Newmenuiteam");
    };

    return (
        <div
            id="homepageTopRestaurants" style={styles.restaurantCardsContainer}>
            {loading && <p style={styles.loadingText}>Loading...</p>}
            {error && <p style={styles.errorText}>{error}</p>}
            <h1

                style={{
                    textAlign: "center",
                    fontSize: "3.5rem",
                    fontWeight: "700",
                    fontFamily: "'Inter', sans-serif",
                    margin: "2rem 0",
                    position: "relative",
                    display: "inline-block",
                    left: "50%",
                    transform: "translateX(-50%)"
                }}>
                <span style={{
                    color: "#2a0947",
                    position: "relative",
                    zIndex: 2
                }}>
                    Top Restaurants
                </span>

            </h1>

            <div style={styles.mainContentWrapper}>
                {/* Cards Container - Column 7 */}
                <div
                    style={{
                        ...styles.cardsContainer,
                        ...styles.cardsContainerScroll
                    }}>
                    <div style={styles.cardsGrid}>
                        {loading ? (
                            <p style={styles.loadingText}>Loading...</p>
                        ) : error ? (
                            <p style={styles.errorText}>{error}</p>
                        ) : filteredCards.length === 0 ? (
                            <p style={styles.emptyText}>No restaurants found</p>
                        ) : (
                            filteredCards.map((card) => (
                                <RestaurantCard
                                    key={card.vendorId}
                                    card={card}
                                    onClick={() => handleCardClick(card.vendorId)}
                                />
                            ))
                        )}
                    </div>
                </div>

            </div>
            {/* Advertisements - Column 3 */}


            {/* <div
                style={{
                    ...styles.advertisementsColumn,
                    display: isMobile ? "none" : "block"
                }}
            >
                <SidescrollAdvertisements />
            </div> */}
        </div>
    );
};

export default MainPageRestaurantCards;